<template>
  <div class="general-info-wrap center-setting">
    <a-row :gutter="[20, 0]">
      <a-col :span="16">
        <!-- 佛山时背景图改变 -->
        <div class="search-wrap"
             :class="{ searchWrapBck: key === 'foShan' }">
          <InputSearch ref="reff"
                       class="searchItem"
                       placeholder="输入关键字搜索"
                       @search="handleSearch"
                       :keywords="keywords"
                       :isBtn="true"></InputSearch>
        </div>
        <div class="switch-wrap">
          <Tabs :tabList="titles"
                @selectTab="selectTab"
                :selectedIndx="selectedIndx"
                :justifyContent="'left'"></Tabs>
          <div class="resultList"
               v-if="result.length > 0">
            <div class="result-wrap"
                 v-for="item in result"
                 :key="item.id"
                 @click="toDetails(item.id)">
              <div class="result-title">
                {{ item.title }}
              </div>
              <div class="result-time">发布时间：{{ item.publishTime }}</div>
            </div>
          </div>
          <div class="empty-content-wrap" v-else>
            <Empty></Empty>
          </div>
          <Pagination :total="total"
                      @pageChange="change"
                      ref="pagination"></Pagination>
        </div>
      </a-col>
      <a-col :span="8">
        <!-- <TitleCard title="热门文章" :showMore="false">
          
        </TitleCard> -->
        <div class="hotBlock">
          <div class="titleText">
            <img src="../../assets/images/jx.png" />
            <span>热门文章</span>
          </div>
          <div class="general-side-wrap generalInfos-list-wrap">
            <!-- 中山dom -->
            <div class="zs-head-bg-wrap"
                 v-if="showZsTitleBgDom">
              <span class="split-line"></span>
            </div>
            <span v-if="emptyOptHot.isEmpty"
                  v-empty="emptyOptHot"></span>
            <template v-else>
              <div class="list-item-wrap"
                   v-for="(listIten, index) in result2"
                   :key="index">
                <div class="fText"
                     @click="toDetails(listIten.id)">
                  {{ listIten.title }}
                </div>
              </div>
            </template>
          </div>
          <!-- <div class="general-side-wrap generalInfos-list-wrap" v-else>
            <Empty></Empty>
          </div> -->
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import InputSearch from '@/components/InputSearch/index.vue'
import Pagination from '@/components/common/Pagination'
import { getMGeneralInfo, getHotInfo } from '@/api/MGeneralInfo.js'
import testData from './data.js'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import Empty from '@/components/common/Empty'
import { projectKey } from '@/utils/gettingEnv'
import { mapGetters, mapMutations } from 'vuex'
import Tabs from '@/components/tabs'
export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      loading: false,
      isEmpty: false,
      showZsTitleBgDom: false, // 中山项目的背景
      emptyOpt: {
        isEmpty: false,
      },
      emptyOptHot: {
        isEmpty: false,
      },
      Params2: { pageSize: 10, pageNum: 1 },
      searchParams: { pageSize: 10, pageNum: 1 },
      total: 0,
      titles: [
        { name: '综合信息', id: '' },
        { name: '行业资讯', id: '1' },
        { name: '政策制度', id: '2' },
        { name: '产业分析', id: '3' },
        { name: '成果公示', id: '4' },
      ],
      selectedLabel: '',
      testData: testData.sideList, // 侧边栏结果
      resultList: testData.resultList, // 检索结果
      result: [],
      result2: [],
      title: '',
      keywords: '',
      selectedIndx: 0,
      selectedTab: '',
      key: '', //
    }
  },
  components: {
    InputSearch,
    Pagination,
    Empty,
    Tabs,
  },
  computed: {
    ...mapGetters('headerSearch', ['headSearchValueInfo']),
    projectKey() {
      return projectKey()
    },
  },
  watch: {
    $route: {
      handler(nVal) {
        this.searchKeys()
        const { id } = nVal.query
        const { informationType } = nVal.query
        this.selectedLabel = id || informationType || ''
        this.searchParams.informationType = this.selectedLabel
        this.searchParams.pageNum = 1
        this.loadData()
      },
      immediate: true,
    },
    // headSearchValueInfo: {
    //   handler() {
    //     this.searchKeys()
    //     this.loadData()
    //   },
    //   immediate: true
    // }
  },
  mounted() {
    this.key = process.env.VUE_APP_KEY
    this.loadHotData()
    this.diffProjectParamsChange()
  },
  methods: {
    ...mapMutations('headerSearch', ['updateTabValue']),
    diffProjectParamsChange() {
      switch (this.projectKey) {
        case 'zhongshan':
          this.showZsTitleBgDom = true
          break

        default:
          // 默认是广州的
          break
      }
    },
    searchKeys() {
      this.keywords = this.headSearchValueInfo
      this.handleSearch(this.headSearchValueInfo)
      let { keywords } = this.$route.query
      if (keywords && keywords !== '') {
        this.keywords = keywords
        this.handleSearch(keywords)
      }
    },
    // 加载文章
    async loadData() {
      this.searchParams.title = this.title
      try {
        this.loading = true
        const { rows, total } = await getMGeneralInfo(this.searchParams)
        const row = this.handlerDateFormat(rows)
        this.handlerResultMappings(row)
        this.isEmpty = this.emptyOpt.isEmpty = row.length === 0
        this.result = row
        this.total = total
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    // 加载热门文章
    async loadHotData() {
      const { rows } = await getHotInfo(this.Params2)
      this.result2 = rows
    },
    // 搜索
    async handleSearch(val) {
      this.title = val
      this.searchParams.pageNum = 1
      this.updateTabValue({ key: 'info', value: val })
      this.loadData()
    },
    // 根据顶部选择过滤文章
    async switchTitleHandle(selectedItem) {
      const { id } = selectedItem
      this.searchParams.informationType = id
      this.selectedLabel = id
      this.searchParams.pageNum = 1
      this.$refs.pagination.resetPagination()
      this.loadData()
    },
    // 跳转详情页面
    toDetails(id) {
      this.$router.push({ name: 'generalInfoDetails', query: { id } })
    },
    // 分页
    change(e) {
      this.searchParams.pageNum = e
      this.loadData()
    },
    // tab切换
    selectTab(val) {
      this.selectedIndx = val.index
      this.selectedTab = val.tab.name
      this.searchParams.informationType = val.tab.id
      this.loadData()
    },
  },
  destroyed() {
    this.updateTabValue({ key: 'info', value: '' })
  },
}
</script>
